import * as React from 'react';

import { LucideCode2, LucideFileText } from 'lucide-react';

import { cn } from '../../../lib/stylingUtils';
import { Col, Row } from '../../ui';

type EventDetailContainerProps = {
  title: string;
  showJson: boolean;
  onToggleJson: () => void;
  children: React.ReactNode;
  jsonContent?: string;
  toggleLabels?: {
    details: string;
    json: string;
  };
  className?: string;
};

export const EventDetailContainer = ({
  title,
  showJson,
  onToggleJson,
  children,
  jsonContent,
  toggleLabels = { details: 'Details', json: 'JSON' },
  className,
}: EventDetailContainerProps) => (
  <Col className={cn('@EventDetailContainer', 'flex-1 gap-3', className)} gap3>
    <Row className="items-center justify-between">
      <span className="text-sm font-medium text-neutral/80">{title}</span>
      <Row className="rounded-md border border-neutral/10 p-0.5" gap1>
        <button
          onClick={() => showJson && onToggleJson()}
          className={cn(
            'flex items-center gap-1 rounded px-2 py-1 text-xs transition-colors',
            !showJson
              ? 'bg-primary/10 text-primary'
              : 'text-neutral/60 hover:text-neutral',
          )}
        >
          <LucideFileText size={12} />
          {toggleLabels.details}
        </button>
        <button
          onClick={() => !showJson && onToggleJson()}
          className={cn(
            'flex items-center gap-1 rounded px-2 py-1 text-xs transition-colors',
            showJson
              ? 'bg-primary/10 text-primary'
              : 'text-neutral/60 hover:text-neutral',
          )}
        >
          <LucideCode2 size={12} />
          {toggleLabels.json}
        </button>
      </Row>
    </Row>
    {showJson && jsonContent ? (
      <Col className="flex-1 overflow-hidden rounded-md border border-neutral/10 bg-neutral/2">
        <pre className="flex-1 overflow-auto p-3 font-mono text-xs">
          {(() => {
            try {
              return JSON.stringify(JSON.parse(jsonContent), null, 2);
            } catch {
              return jsonContent;
            }
          })()}
        </pre>
      </Col>
    ) : (
      children
    )}
  </Col>
);
